// ถามกล้องครั้งเดียวต่อกรอบ ก่อนเปิดอะไร — คำตอบบอกว่าจะเปิดทุกกล้องพร้อมกัน หรือทีละกล้อง
// ลองใหม่ = ถามใหม่ (กล่องอาจกลับมาออนไลน์แล้ว)

import { useEffect, useReducer, useState } from 'react'
import { getCameras } from './livestreamApi'
import { toCellError } from './cellState'

const NONE = { discovery: null, error: null }

export default function useCameraDiscovery({ enabled, vehicleId }) {
  const [attempt, rediscover] = useReducer(n => n + 1, 0)
  const [state, setState] = useState(NONE)

  useEffect(() => {
    setState(NONE)
    if (!enabled) return undefined
    let cancelled = false
    getCameras(vehicleId)
      .then(found => {
        if (!cancelled) setState({ discovery: found || {}, error: null })
      })
      .catch(err => {
        if (!cancelled) setState({ discovery: null, error: toCellError(err) })
      })
    return () => {
      cancelled = true
    }
  }, [enabled, vehicleId, attempt])

  return { ...state, rediscover }
}
